export var PlayerRankType;
(function (PlayerRankType) {
    PlayerRankType["SILVER"] = "silver";
    PlayerRankType["GOLD"] = "gold";
    PlayerRankType["DIAMOND"] = "diamond";
    PlayerRankType["CROWN"] = "crown";
    PlayerRankType["GLORY"] = "glory";
    PlayerRankType["KING"] = "king";
    PlayerRankType["MASTER"] = "master";
})(PlayerRankType || (PlayerRankType = {}));
//# sourceMappingURL=PlayerRankType.js.map